/* eslint-disable no-empty-function */

/**
 * Helper function to type the text into the input field one character at a time.
 * @function typeWriterHelper
 * @param {HTMLInputElement} $field - The input field where text is typed.
 * @param {String} text - The text to be typed into the input field.
 * @param {Number} index - Current position in the text string.
 * @param {Function} onEnd - Callback function to be called when typing is complete.
 */
const typeWriterHelper = ( $field, text, index, onEnd ) => {
	try {
		// Validate the $field parameter
		if ( ! ( $field instanceof HTMLElement ) ) {
			throw new TypeError( 'typeWriter: Invalid field element provided' );
		}

		// Validate the text parameter
		if ( typeof text !== 'string' ) {
			throw new TypeError( 'typeWriter: Text must be a string' );
		}

		// Validate the index parameter
		if ( typeof index !== 'number' || ! Number.isInteger( index ) || index < 0 ) {
			throw new TypeError( 'typeWriter: Index must be a non-negative integer' );
		}

		// Validate the onEnd parameter
		if ( typeof onEnd !== 'function' ) {
			throw new TypeError( 'typeWriter: onEnd must be a function' );
		}

		// Check if there are more characters to type
		if ( index < text.length ) {
			// Append the next character to the input field's value
			$field.value += text[ index ];

			// Call typeWriterHelper recursively with the next index after a delay
			setTimeout( () => typeWriterHelper( $field, text, index + 1, onEnd ), 50 );
		} else {
			// If typing is complete, call the onEnd callback function
			onEnd();
		}
	} catch ( error ) {
		// Log any errors that occur to the console
		console.error( 'An error occurred:', error.message );
	}
};

/**
 * Types the text into the input field one character at a time.
 * @function typeWriter
 * @param {HTMLInputElement} $field - The input field where text is typed.
 * @param {String} text - The text to be typed into the input field.
 * @param {Function} [onEnd=() => {}] - Callback function to be called when typing is complete.
 */
const typeWriter = ( $field, text, onEnd = () => {} ) => {
	typeWriterHelper( $field, text, 0, onEnd );
};

export default typeWriter;
